var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageCta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.71 17.99C8.53 17.84 6 15.22 6 12C6 8.69 8.69 6 12 6C15.22 6 17.84 8.53 17.99 11.71L15.89 11.08C15.48 9.31 13.89 8 12 8C9.79 8 8 9.79 8 12C8 13.89 9.31 15.48 11.08 15.89L11.71 17.99ZM22 12C22 12.3 21.99 12.6 21.96 12.9L19.99 12.31C20 12.21 20 12.1 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C12.1 20 12.21 20 12.31 19.99L12.9 21.96C12.6 21.99 12.3 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12ZM18.23 16.26L20.5 15.5C20.96 15.35 20.95 14.69 20.49 14.55L12.89 12.27C12.51 12.16 12.15 12.51 12.27 12.89L14.55 20.49C14.69 20.96 15.35 20.97 15.5 20.5L16.26 18.23L20.17 22.14C20.37 22.34 20.68 22.34 20.88 22.14L22.15 20.87C22.35 20.67 22.35 20.36 22.15 20.16L18.23 16.26Z",
    fill: "#001B53",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageCta);
export default __webpack_public_path__ + "static/media/pageCta.b2018950400ef8b649ed7dad4bdd78f8.svg";
export { ForwardRef as ReactComponent };